import { message } from 'antd';
import moment from 'moment';
import { ds, isOriginCenter, scanType } from '@/models/fieldConv'

const pereTime = 86400 * 1000 * 1  // n天前时间毫秒

const params = {
  scanSite: '',
  scanProvinceArea: '',
  startDate: moment(new Date().getTime()).format("YYYY-MM-DD 00:00:00"),
  endDate: moment(new Date().getTime()).format("YYYY-MM-DD 23:59:59"),
};
export default {
  namespace: 'centermassagemap',
  state: {
    value: [],
    arrived: [],
    searchParams: { ...params },
  },

  effects: {
    *getData({ payload }, { put, select }) {
      const { searchParams } = yield select(({ centermassagemap }) => centermassagemap);
      if (!searchParams.startDate || !searchParams.endDate) {
        return message.error('请选择一个时间范围!')
      }
      for (let index = 0; index < ds.length; index++) {
        const filterCallBack = (andFilters, inFilters) => {
          const andf = payload.params.andFilters
          if (andf) {
            if (andf.isOriginCenter !== undefined) {
              andFilters.push({ key: 'isOriginCenter', value: isOriginCenter[andf.isOriginCenter + index * 2] })
            }
            if (andf.scanType !== undefined) {
              andFilters.push({ key: 'scanType', value: scanType[andf.scanType + index * 2] })
            }
          }
          const inf = payload.params.inFilters
          if (inf) {
            if (inf.scanType) {
              const value = inf.scanType.map(item => scanType[item + index * 2])
              inFilters.push({ key: 'scanType', value })
            }
          }

          if (searchParams.scanSite && searchParams.scanSite.name) {
            let siteName = searchParams.scanSite.name
            if (siteName.slice(siteName.length - 4, siteName.length) === '分拨中心') {
              siteName = searchParams.scanSite.name.slice(0,
                searchParams.scanSite.name.length - 4)
            }
            andFilters.push({ key: 'scanSite', value: siteName });
          }
          if (searchParams.scanProvinceArea && searchParams.scanProvinceArea.name) {
            andFilters.push({
              key: 'scanProvinceArea',
              value: searchParams.scanProvinceArea.name,
            });
          }
        }

        yield put({
          type: 'druid/druidFetch',
          payload: {
            params: {
              ...payload.params,
              startDate: searchParams.startDate,
              endDate: searchParams.endDate
            },
            effectName: payload.effectName,
            index,
            filterCallBack
          }
        });
      }
    },
  },

  reducers: {
    updateState(state, { payload }) {
      return { ...state, ...payload };
    },
    searchParamsUpdate(state, { payload }) {
      const searchParams = { ...state.searchParams, ...payload };
      return { ...state, searchParams };
    },
    resetSearchParam(state) {
      return { ...state, searchParams: { ...params } };
    },
  },
};
